import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=3c5d4b00&scoped=true&style=height%3A%20100%25&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "./materialList.vue?vue&type=style&index=0&id=3c5d4b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d4b00",
  null
  
)

export default component.exports